const constants = require('@/util/constants')
require('./config')

// 静态化
export function staticizeKnowledgebase(successcb, failedcb) {
    axios.get('/api/knowledgebase/staticize', {
        params: {
            'client': constants.HTTP_CLIENT
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

export function queryKnowledgebase(successcb, failedcb) {
    axios.get('/api/knowledgebase/query', {
        params: {
            'client': constants.HTTP_CLIENT
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

export function createKnowledgebase(knowledgebase, successcb, failedcb) {
    axios.post('/api/article/create', {
        name: knowledgebase.name,
        headline: knowledgebase.headline,
        language: knowledgebase.language,
        subDomain: knowledgebase.subDomain,
        url: knowledgebase.url,
        logo: knowledgebase.logo,
        favicon: knowledgebase.favicon,
        primaryColor: knowledgebase.primaryColor,
        description: knowledgebase.description,
        header: knowledgebase.header,
        footer: knowledgebase.footer,
        css: knowledgebase.css,
        showKeFu: knowledgebase.showKeFu,
        appointed: knowledgebase.appointed,
        type: knowledgebase.type,
        workGroupWid: knowledgebase.workGroupWid,
        agentUid: knowledgebase.agentUid,
        client: constants.HTTP_CLIENT
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

export function updateKnowledgebase(knowledgebase, successcb, failedcb) {
    axios.put('/api/article/update', {
        name: knowledgebase.name,
        headline: knowledgebase.headline,
        language: knowledgebase.language,
        subDomain: knowledgebase.subDomain,
        url: knowledgebase.url,
        logo: knowledgebase.logo,
        favicon: knowledgebase.favicon,
        primaryColor: knowledgebase.primaryColor,
        description: knowledgebase.description,
        header: knowledgebase.header,
        footer: knowledgebase.footer,
        css: knowledgebase.css,
        showKeFu: knowledgebase.showKeFu,
        appointed: knowledgebase.appointed,
        type: knowledgebase.type,
        workGroupWid: knowledgebase.workGroupWid,
        agentUid: knowledgebase.agentUid,
        client: constants.HTTP_CLIENT
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

export function filterKnowledgebase(content, successcb, failedcb) {
    axios.get('/api/knowledgebase/filter', {
        params: {
            'page': 0,
            'size': 20,
            'content': content,
            'client': constants.HTTP_CLIENT
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}
